import { getYear } from "date-fns"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { networkGradingsQueryKeys } from "./queryKeys"
import { useListNetworkGradings } from "./useNetworkGradings"

export function useMultiYearGrading(config = {}) {
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork?.slug}/`

    const queryKey = [...networkGradingsQueryKeys["list"](), "multiGradingsYears"]

    const { data, isLoading, isError } = useListNetworkGradings(
        url,
        [queryKey],
        config,
    )

    const nowYear = getYear(new Date())
    const resultData = data
        ?.map(data => data.year)
        ?.filter(year => nowYear <= year)
        ?.sort((a, b) => a - b)

    return ({
        data: resultData,
        isError,
        isLoading,
    })
}